import { API } from '@utils/axios'

export async function fetchVidelReports (params: any) {
  const response = await API.get('/VideoGoLiverManagement/ListVideo', { params })
  return response.data
}

export async function fetchReports (params: any) {
  const response = await API.get('/VideoGoLiverManagement/ListReport', { params })
  return response.data
}

export async function fetchVideoComments (params: any) {
  const response = await API.get('/VideoGoLiverCommentManagement/GetList', { params })
  return response.data
}

export async function fetchAdminNotes (id: string) {
  const response = await API.get(`/VideoGoLiverCommentManagement/GetAdminActionList?commentId=${id}`)
  return response.data
}

export async function setCommentBlocked (params: any) {
  const response = await API.patch('/VideoGoLiverCommentManagement/SetBlocked', params)
  return response.data
}

export async function confirm (data: any) {
  const response = await API.post('/VideoGoLiverManagement/ConfirmReport', data)
  return response.data
}

export async function block (data: any) {
  const response = await API.post('/VideoGoLiverManagement/BlockVideo', data)
  return response.data
}

export async function unconfirm (data: any) {
  const response = await API.post('/VideoGoLiverManagement/UnconfirmReport', data)
  return response.data
}

export async function unblock (data: any) {
  const response = await API.post('/VideoGoLiverManagement/UnblockVideo', data)
  return response.data
}

export async function note (data: any) {
  const response = await API.post('/VideoGoLiverManagement/NoteVideo', data)
  return response.data
}

export async function download (params: any) {
  const response = await API.get('/VideoGoliverManagement/Download', { params, responseType: 'blob' })
  return response.data
}

export async function approve (id: string) {
  const response = await API.patch('/VideoGoliverManagement/Approve', { videoGoLiverId: id })
  return response.data
}

export async function getViewNumberHistories (id: string) {
  const response = await API.get(`/VideoGoliverManagement/GetViewNumberHistories/${id}`)
  return response.data
}

export async function addViewNumberHistory (params: any) {
  const response = await API.post('/VideoGoliverManagement/AddViewNumberHistory', params)
  return response.data
}

// purchase method
export async function getVideoPurchaseMethodList () {
  const response = await API.get('/VideoPurchaseMethodManagement/GetList')
  return response.data
}

export async function getSingleVideoPurchaseMethod (id: string) {
  const response = await API.get(`/VideoPurchaseMethodManagement/GetById?id=${id}`)
  return response.data
}

export async function addVideoPurchaseMethod (params: any) {
  const response = await API.post('/VideoPurchaseMethodManagement/Create', params)
  return response.data
}

export async function updateVideoPurchaseMethod (params: any) {
  const response = await API.put('/VideoPurchaseMethodManagement/Update', params)
  return response.data
}

export async function deleteVideoPurchaseMethod (id: string) {
  const response = await API.delete(`/VideoPurchaseMethodManagement/Delete?id=${id}`)
  return response.data
}

export async function addPurchaseMethodsToVideo (params: any) {
  const response = await API.post('/VideoPurchaseMethodManagement/AddPurchaseMethodsToVideo', params)
  return response.data
}

// video choice
export async function getVideoChoiceList () {
  const response = await API.get('/VideoChoiceManagement/GetList')
  return response.data
}

export async function getSingleVideoChoice (id: string) {
  const response = await API.get(`/VideoChoiceManagement/GetById?id=${id}`)
  return response.data
}

export async function addVideoChoice (params: any) {
  const response = await API.post('/VideoChoiceManagement/Create', params)
  return response.data
}

export async function updateVideoChoice (params: any) {
  const response = await API.put('/VideoChoiceManagement/Update', params)
  return response.data
}

export async function deleteVideoChoice (id: string) {
  const response = await API.delete(`/VideoChoiceManagement/Delete?id=${id}`)
  return response.data
}

export async function addChoicesToVideo (params: any) {
  const response = await API.post('/VideoChoiceManagement/AddChoicesToVideo', params)
  return response.data
}

// video genre

export async function getVideoGenreList () {
  const response = await API.get('/VideoGenreManagement/GetList')
  return response.data
}

export async function getSingleVideoGenre (id: string) {
  const response = await API.get(`/VideoGenreManagement/GetById?id=${id}`)
  return response.data
}

export async function addVideoGenre (params: any) {
  const response = await API.post('/VideoGenreManagement/Create', params)
  return response.data
}

export async function updateVideoGenre (params: any) {
  const response = await API.put('/VideoGenreManagement/Update', params)
  return response.data
}

export async function deleteVideoGenre (id: string) {
  const response = await API.delete(`/VideoGenreManagement/Delete?id=${id}`)
  return response.data
}

export async function addGenresToVideo (params: any) {
  const response = await API.post('/VideoGenreManagement/addGenresToVideo', params)
  return response.data
}

export async function getVideoTags (id: string) {
  const response = await API.get(`/VideoGoLiverManagement/GetTags?id=${id}`)
  return response.data
}

export async function updateTags (params: any) {
  const response = await API.put('/VideoGoLiverManagement/UpdateTags', params)
  return response.data
}

export async function uploadVideo (params: any) {
  const response = await API.post('/VideoGoLiverManagement/Create', params)
  return response.data
}
